/**
* @ngdoc component
* @name common.component:itxContactTopic
* @description
* Component description
*/
(function() {
  'use strict';

  var itxContactTopic = {
    bindings: {
      storeType: '<',
      model:'<',
      form:'='
    },
    controller:   itxContactTopicCtrl,
    templateUrl: 'contact-topic.component.html'
  };

  itxContactTopicCtrl.$inject = [
    '$timeout',
    'ItxTranslateSvc'
  ];

  function itxContactTopicCtrl (
    $timeout,
    ItxTranslateSvc
  ) {
    var _this = this;

    _this.onlineTopics = [
      {id:1, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.online.option.0')},
      {id:2, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.online.option.1')},
      {id:3, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.online.option.2')},
      {id:4, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.online.option.3')},
      {id:5, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.online.option.4')}
    ];
    
    _this.storeTopics = [
      {id:1, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.store.option.5')},
      {id:2, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.store.option.6')},
      {id:3, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.store.option.7')},
      {id:4, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.store.option.8')},
      {id:5, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.store.option.9')},
      {id:6, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.store.option.10')},
      {id:7, topic: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.store.option.11')}
    ];

    _this.$onInit = function () {
      _this.topicsOpened = false;
      _this.model.topic = _this.onlineTopics[0].topic;
      _this.model.topic = _this.storeTopics[0].topic;
      // _this.topics = _this.onlineTopics;

      // _this.topics = _this.onlineTopics;

       // adapt topics for worldwide
       if(_this.isWW){  
        _this.storeTopics.splice(2,1);
      }

      
    };

    _this.$onChanges = function(changeObj){
      if(changeObj.storeType.currentValue != changeObj.storeType.previousValue){ 
        if(changeObj.storeType.currentValue === 1) {
          _this.topics = _this.onlineTopics;
        } else {
          _this.topics = _this.storeTopics;
        }
      }
     };
  

    _this.onTopicEvent = function (opened) {
      $timeout(function () {
          _this.topicsOpened = opened;
      });
    };

    _this.onTopicSelected = function (topic) {
      _this.model.topic = topic.topic;
       _this.model.type = topic.id;
    };

  }

  angular.module('itxApp.common')
  .component('itxContactTopic',itxContactTopic);

})();